<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
      <div>
        <el-card class="NumberCardWidth">
          <div class="deal flex-between">
            <div class="card-text">
              <h3>客户维护记录</h3>
            </div>
            <div class="card-button">
              <el-button
                class="push-button"
                @click="NvagetToLookMenber"
                icon="iconfont icon-fanhui"
                plain
                >返回基本信息</el-button
              >
            </div>
          </div>
          <div class="NumberTable">
            <!-- table列表 -->
            <Table
              @TouchTheBottom="TouchTheBottom"
              :PagesData="paging"
              :tableData="list.tbody"
              :configTable="list.thead"
              :config="list"
            ></Table>
          </div>
        </el-card>
      </div>
      <!-- 右侧列表相关链接 -->
      <!-- 使用封装的组件 -->
      <div class="PagesContentRight">
        <RightCard></RightCard>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetMaintaiPage } from "@/api/viewMemberModule";
import { getcpyNo } from "@/utils/auth";
import Table from "/src/components/NumberTable/index.vue";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages: 2,
        Loading: true,
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "单据号",
            prop: "maintainNo",
          },
          {
            label: "是否删除",
            prop: "stateText",
          },
          {
            label: "维护主题",
            prop: "subjectName",
          },
          {
            label: "维护方式",
            prop: "maintainType",
          },
          {
            label: "维护日期",
            prop: "maintainDate",
            width: 180,
          },
          {
            label: "预计到店日期",
            prop: "planDate",
            width: 180,
          },
          {
            label: "是否试衣",
            prop: "isDressing",
          },
          {
            label: "维护反馈",
            prop: "dressingFeedback",
          },
        ],
        tbody: [],
      },
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  created() {
    this.RGetMaintaiPage();
  },
  methods: {
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
    RGetMaintaiPage() {
      let data = require("qs").stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetMaintaiPage(data).then((res) => {
        if (res.success) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
            item.dressingFeedback =
              item.dressingFeedback == 1
                ? "感兴趣"
                : item.dressingFeedback == 2
                ? "不感兴趣"
                : "";
            item.stateText =
              item.state == 0 ? "否" : item.state == 1 ? "是" : "";
            item.maintainDate = this.renderTime(item.maintainDate);
            item.planDate = this.renderTime(item.planDate);
          });
          this.list.tbody = this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
        this.paging.Loading = false;
      });
    },
    TouchTheBottom() {
      this.paging.page++;
      this.RGetMaintaiPage();
    },
    renderTime(date) {
      if (date != null) {
        var dateee = new Date(date).toJSON();
        return new Date(+new Date(dateee) + 8 * 3600 * 1000)
          .toISOString()
          .replace(/T/g, " ")
          .replace(/\.[\d]{3}Z/, "");
      } else {
        return "";
      }
    }
  },
};
</script>
<style lang="scss" scoped>
.NumberCardWidth {
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  margin-left: 25px;
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
}

// 按钮边框去掉，文字颜色和加粗
/deep/button {
  border-color: #e6e0af;
  border-radius: 7px;
  color: #a19b59;
}
</style>
